import app from "./app/application/index"
import {vsBootstrapModuleName} from './app/application/names'
import { initializeUserProfileModule } from './app/application/userProfileModule'
import apiCheck from 'api-check'

function bootstrap(profile, environment, appInfo, processGroups) {
  angular
    .module(vsBootstrapModuleName, [])
    .constant('environment', environment)
    .constant('applicationInfo', appInfo)
    .constant('processGroups', processGroups)
  
  initializeUserProfileModule(profile)  

  //if this is not done, horrendous performance problems on forms.
  //you won't get apiCheck errors when developing forms with angular-formly
  //but at this point, we aren't going to add many new items until new client
  apiCheck.globalConfig.disabled = true

  angular.bootstrap(document, [vsBootstrapModuleName, app, "SlotTrak.Machines"], {
    strictDi: true
  })

}
export default bootstrap